import EDTStepper from "../../features/stepper/EDTStepper";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsProjects } from "../../constants/projects";

const CreateEDT = ({ API_URL, typeWorks }) => {
  return (
    <div style={{ display: "flex", width: "90%" }}>
      <div style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div style={{ flex: 1, padding: "10px", width: "100%" }}>
        <EDTStepper typeWorks={typeWorks} API_URL={API_URL} />
      </div>
    </div>
  );
};

export default CreateEDT;
